<template>
  <div class="wallpaper-detail-wrap">
    <vue-scroll
      ref="vueScroll"
      class="vue-scroll"
      @handle-scroll="handleScroll"
    >
      <div class="bd">
        <PersonalMobileWallpaperDetail
          :info="personalInfo"
          :dynamicdetail="dynamicDetail"
          @close="close"
        />
        <div class="line" />
        <div class="other">
          该作者的其他壁纸
        </div>
        <div class="list">
          <ul>
            <li
              v-for="item in list"
              :key="item.wid"
              class="item"
              :data-wid="item.wid"
              @click="handleViewDetail"
            >
              <PersonalWallpaperItem
                :data="item"
              />
            </li>
          </ul>
        </div>
        <div class="footer-empty" />
        <div class="footer" @click="clickClose">
          <div class="footer-btn">
            下载元气桌面电脑版，查看更多
          </div>
        </div>
      </div>
    </vue-scroll>
    <LinkDialog v-if="linkDialogVisible" @close="close" />
  </div>
</template>

<script>
import { fetchDynamicDetail, fetchInfo, fetchWorks } from '@/api/personal'

import PersonalMobileWallpaperDetail from '@/components/PersonalMobileWallpaperDetail'
import PersonalWallpaperItem from '@/components/PersonalMobileWallpaperItem'
import LinkDialog from '@/components/LinkDialog'

const WTYPE_DYNAMIC_AND_SENCE = 2
const WTYPE_STATIC = 3
const SCROLL_RATE = 1.8

export default {
  name: 'MobileWallpaperDetail',
  components: {
    PersonalMobileWallpaperDetail,
    PersonalWallpaperItem,
    LinkDialog,
  },
  data() {
    let dwid
    const query = this.$route.query
    if (+query.dwid) {
      dwid = +query.dwid
    }

    return {
      uid: null,
      dwid,
      personalInfo: {},
      wtype: WTYPE_DYNAMIC_AND_SENCE,
      list: [],
      page: 1,
      pageSize: 54,
      total: 0,
      isEmpty: false,
      panelHeight: 0,
      contentHeight: 0,
      loading: false,
      listEnd: false,
      dynamicDetail: {},
      linkDialogVisible: false,
    }
  },
  computed: {
  },
  async mounted() {
    this.resize()
    await this.fetchDynamicDetail()
    this.fetchInfo()
    this.fetchWorks()
  },
  methods: {
    clickClose() {
      this.close(true)
    },
    close(visible) {
      this.linkDialogVisible = visible
    },
    resize() {
      const designSize = 375
      const html = document.documentElement
      const wW = html.clientWidth
      const rem = (wW / designSize) * 100
      html.style.fontSize = `${rem}px`
    },
    showEmpty() {
      this.isEmpty = true
    },
    hideEmpty() {
      this.isEmpty = false
    },
    handleScroll({ scrollTop }) {
      if (!this.panelHeight) {
        this.panelHeight = this.$refs.vueScroll.scrollPanelElm.offsetHeight
      }

      if (this.loading) {
        return
      }

      if (this.listEnd) {
        return
      }

      if (!Object.keys(this.list).length) {
        return
      }

      this.contentHeight = this.$refs.vueScroll.scrollContentElm.offsetHeight

      if (scrollTop < this.contentHeight - this.panelHeight * SCROLL_RATE) {
        return
      }

      this.fetchInfiniteData()
    },
    handleSwitch(params = {}) {
      if (params.type === 'dynamic') {
        if (this.wtype === WTYPE_DYNAMIC_AND_SENCE) {
          return
        }
        this.wtype = WTYPE_DYNAMIC_AND_SENCE
      }

      if (params.type === 'static') {
        if (this.type === WTYPE_STATIC) {
          return
        }
        this.wtype = WTYPE_STATIC
      }

      this.page = 1
      this.fetchWorks()
    },
    handleViewDetail($event) {
      const wid = +$event.currentTarget.dataset.wid
      const loc = window.location
      if (wid) {
        window.open(`${loc.protocol}//${loc.host}/personal/wallpaper?dwid=${wid}`, '_self')
      }
    },
    async fetchDynamicDetail() {
      try {
        const res = await fetchDynamicDetail({
          wid: this.dwid,
        })

        if (res.resp_common && !res.resp_common.ret) {
          this.dynamicDetail = res.data
          this.uid = res.data.author_uid
        }
      } catch (err) {
        // TODO
      }
    },
    async fetchInfo() {
      console.log(this.uid)
      if (!this.uid) {
        return
      }

      try {
        const res = await fetchInfo({
          author_uid: this.uid,
        })

        if (res.resp_common && !res.resp_common.ret) {
          this.personalInfo = res.user_info
        }
      } catch (err) {
        // TODO
      }
    },
    async fetchWorks(options = {}) {
      const { isInfinite = false } = options
      if (!isInfinite) {
        this.list = []
      }

      try {
        this.loading = true
        const res = await fetchWorks({
          author_uid: this.uid,
          wtype_support: this.wtype,
          page_size: this.pageSize,
          page: this.page,
        })

        if (res.resp_common && !res.resp_common.ret) {
          this.total = res.data.total
          const list = []
          if (res.data.list) {
            res.data.list.forEach((item) => {
              if (item.wid !== this.dwid) {
                list.push(item)
              }
            })
          }

          if (isInfinite) {
            this.list = this.list.concat(list)
          } else {
            this.list = list
          }
        }
      } catch (err) {
        // TODO
      }

      if (this.list.length) {
        this.hideEmpty()
      } else {
        this.showEmpty()
      }

      this.loading = false
    },
    async fetchInfiniteData() {
      if (this.listEnd) {
        return
      }

      if (!Object.keys(this.list).length) {
        return
      }

      this.loading = true
      this.page++

      try {
        await this.fetchWorks({
          isInfinite: true,
        })
      } catch (err) {
        // TODO
      }

      this.loading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.wallpaper-detail-wrap {
  height: 100%;
  width: 3.75rem;
  box-sizing: border-box;
  padding: 0 .15rem 0 0;
  background: #fff;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
}
.bd {
  background: #fff;
  border-radius: 6px;
  width: 100%;
  box-sizing: border-box;
}
.list {
    width: calc(3.75rem - .3rem);
    margin-left: 0.15rem;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
  ul {
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    &::after {
      content: '';
      display: table;
      clear: both;
    }
  }
  .item {
    cursor: pointer;
    width: 1.65rem;
    height: .92rem;
    border-radius: 8px;
    margin-bottom: .15rem;
    &:nth-child(2n) {
    margin-right: .04rem;
    }
  }
}
.line {
  height: 1px;
  margin: 0 18px 20px;
  background: #F7F8F8;
}
.other {
    display: flex;
    justify-content: center;
    width: calc(3.75rem - .07rem);
    box-sizing: border-box;
    margin-top: .17rem;
    font-size: .15rem;
    margin-top: .2rem;
    margin-bottom: .17rem;
    color: #333;
}
.footer-empty {
  width: 0;
  height: .75rem;
}
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 3.75rem;
  height: .75rem;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #FFFFFF 100%);
  display: flex;
  justify-content: center;
}
.footer-btn {
  width: 3.35rem;
  height: .45rem;
  cursor: pointer;
  background: linear-gradient(90deg, #FFDA56 0%, #FACA2A 100%);
  border-radius: 10px;
  font-size: 15px;
  text-align: center;
  line-height: .45rem;
  position: absolute;
  bottom: 15px;
  &::after {
    width: 15px;
    height: 11px;
    display: inline-block;
    content:'';
    margin-left: .06rem;
    background: url('~@/assets/images/go.png') 0 0 no-repeat;
    background-size: 100% 100%;
  }
}
</style>
